module.exports = __webpack_public_path__ + "media/วอเอเอเอวอเอ.1f171fcd.mp3";